import React, { useContext, useCallback, useState } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { ICreateModifierContext, CreateModifierContext } from '../createModifierState/createModifierContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import Text from 'components/Text/Text';
import { Radio } from 'antd';
import { createModifierV2 } from 'backend/modifiers';
import { useHistory } from 'react-router-dom';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { resetFields, changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<ICreateModifierContext>(CreateModifierContext);
	const history = useHistory();
	const [typeOfSaving, setTypeOfSaving] = useState<'finishCreation' | 'editRestProps'>('finishCreation');

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			changeTypeOfModalWindow(null);
			const convertedData = convertUndefinedFields(dataForSubmit);
			showLoader();
			const response = await createModifierV2(convertedData);
			if (response && response.status >= 200 && response.status < 299) {
				if (typeOfSaving === 'finishCreation') {
					changeTypeOfModalWindow('success');
				} else {
					history.push(`/menu-v2/modifiers/edit-restaurant-properties?modifierID=${response.data.id}`);
				}
			} else if (response) {
				changeTypeOfModalWindow('error');
			}
			hideLoader();
		}
	}, [dataForSubmit, typeOfSaving]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={resetFields}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && !dataForSubmit?.restaurantIds.length && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'toConfirmSubmit'}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && !!dataForSubmit?.restaurantIds.length && (
				<ModalContent
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					heading="selectWhenSavingModifier"
					headingAlignment="left">
					<Text translationNameSpace="form" translationKey="hintOfSelectWhenSavingModifier" size="s" />
					<div className={style.radioWrapper}>
						<Radio
							checked={typeOfSaving === 'finishCreation'}
							onClick={() => setTypeOfSaving('finishCreation')}>
							<Text translationNameSpace="form" translationKey="finishCreation" size="s" weight="bold" />
						</Radio>
						<Radio
							checked={typeOfSaving === 'editRestProps'}
							onClick={() => setTypeOfSaving('editRestProps')}>
							<Text
								translationNameSpace="form"
								translationKey="editRestaurantProperties"
								size="s"
								weight="bold"
							/>
						</Radio>
					</div>
				</ModalContent>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully onConsentEvent={resetFields} isVisible={true} description="savedSuccessfully" />
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'defaultTranslationIsEmpty' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorDefaultTranslationOnBlock"
				/>
			)}
		</ModalWrapper>
	);
};
